import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "el-time-panel"
}
const _hoisted_2 = { class: "el-time-panel__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_time_spinner = _resolveComponent("time-spinner")!

  return (_openBlock(), _createBlock(_Transition, { name: _ctx.transitionName }, {
    default: _withCtx(() => [
      (_ctx.actualVisible || _ctx.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: _normalizeClass(["el-time-panel__content", { 'has-seconds': _ctx.showSeconds }])
            }, [
              _createVNode(_component_time_spinner, {
                ref: "spinner",
                role: _ctx.datetimeRole || 'start',
                "arrow-control": _ctx.arrowControl,
                "show-seconds": _ctx.showSeconds,
                "am-pm-mode": _ctx.amPmMode,
                "spinner-date": _ctx.parsedValue,
                "disabled-hours": _ctx.disabledHours,
                "disabled-minutes": _ctx.disabledMinutes,
                "disabled-seconds": _ctx.disabledSeconds,
                onChange: _ctx.handleChange,
                onSetOption: _ctx.onSetOption,
                onSelectRange: _ctx.setSelectionRange
              }, null, 8, ["role", "arrow-control", "show-seconds", "am-pm-mode", "spinner-date", "disabled-hours", "disabled-minutes", "disabled-seconds", "onChange", "onSetOption", "onSelectRange"])
            ], 2),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("button", {
                type: "button",
                class: "el-time-panel__btn cancel",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCancel && _ctx.handleCancel(...args)))
              }, _toDisplayString(_ctx.t('Controls.DatePicker.Cancel')), 1),
              _createElementVNode("button", {
                type: "button",
                class: "el-time-panel__btn confirm",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleConfirm()))
              }, _toDisplayString(_ctx.t('Controls.DatePicker.Confirm')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["name"]))
}